export default {
  title: {
    list: "運営会社参照許可",
    edit: "運営会社参照許可編集"
  },
  errors: {
    getAccount: "アカウント一覧の取得に失敗しました。",
    getOperationOffice: "運営会社一覧の取得に失敗しました。",
  },
  accountName: "アカウント名",
  operationOffice: "運営会社",
  list: {
    id: "ID",
    officeableType: "アカウント区分",
    officeableName: "所属組織",
    role: "役割",
    driverId: "ドライバーID",
    updatedAt: "最終更新日",
    updatedBy: "最終更新者",
    edit: "編集",
    managementOffice: "管理会社",
    subManagementOffice: "準管理会社",
    installationOffice: "設置会社",
    administrator: "管理者",
    driver: "ドライバー"
  },
  confirmationModal: {
    addConfirmMessage: 'この運営会社への参照を許可しますか？',
    deleteConfirmMessage: "この運営会社への参照を削除しますか？",
    resultPrefix: "参照を",
    success: "しました。",
    failed: "できませんでした。",
    approval: "許可",
    delete: "削除",
    add: "追加"
  },
  selectableStatuses: {
    all: '全て',
    completed: '参照許可済み',
    incompleted: '参照未許可'
  }
}
